import {createSlice} from '@reduxjs/toolkit'
const initialState = {
  linkType: sessionStorage.getItem('kp11-linkType') || null,
  influencerName: '',
  isMobileViewEnabled: false,
}
const KpGlobalStateSlice = createSlice({
  name: 'kpGlobalState',
  initialState,
  reducers: {
    setInfluencerName(state, action) {
      state.influencerName = action.payload
    },
    resetInfluencerName(state) {
      state.influencerName = ''
    },
    setLinkType(state, action) {
      console.log({payload: action.payload})
      state.linkType = action.payload
      if (action.payload) {
        sessionStorage.setItem('kp11-linkType', action.payload)
      } else {
        sessionStorage.removeItem('kp11-linkType')
      }
    },
    resetLinkType(state) {
      state.linkType = null
      sessionStorage.removeItem('kp11-linkType')
    },
    setMobileViewStatus(state, action) {
      state.isMobileViewEnabled = action.payload
    },
  },
})

export const selectedLinkType = state => state.kpGlobalState?.linkType

export const selectedInfluencerName = state =>
  state.kpGlobalState?.influencerName

export const selectedMobileViewEnabledStatus = state =>
  state.kpGlobalState?.isMobileViewEnabled

export const {
  setLinkType,
  resetLinkType,
  setInfluencerName,
  resetInfluencerName,
  setMobileViewStatus,
} = KpGlobalStateSlice.actions
export default KpGlobalStateSlice.reducer
